import { useMemo } from 'react';
import { feedbackStatus } from '../../pages/PerformanceReview/helpers';
import { FeedbackStatusTypes } from '../../pages/PerformanceReview/Reviews/types';
import { FeedbackProps } from '../../pages/PerformanceReview/types';

export type FeedbacksCollection = {
  nextFeedbacks: FeedbackProps[];
  pastFeedbacks: FeedbackProps[];
};

// Same derivation as the reviews tables, so a review can never be labelled
// completed in one place and listed as still active in the other.
const isPastFeedback = (feedback: FeedbackProps): boolean =>
  feedbackStatus(feedback) === FeedbackStatusTypes.Completed;

export const useFeedbacks = (data: readonly FeedbackProps[] | undefined) => {
  const feedbacks: FeedbacksCollection = useMemo(
    () => ({
      nextFeedbacks: (data ?? []).filter(
        (feedback) => !isPastFeedback(feedback),
      ),
      pastFeedbacks: (data ?? []).filter(isPastFeedback),
    }),
    [data],
  );

  return { feedbacks };
};
